const API_PREFIX = process.env.API_PREFIX;
const AUTH_MODE = process.env.AUTH_MODE || 'sanctum';

// Define auth endpoints based on AUTH_MODE
const getAuthEndpoints = () => {
  if (AUTH_MODE === 'auth0') {
    // Use Auth0-specific endpoints
    return {
      LOGIN: `${API_PREFIX}/auth/loginAuth0`,
      LOGOUT: `${API_PREFIX}/auth/logout/logoutAuth0`,
      FORGOT_PASSWORD: `${API_PREFIX}/auth/forgot-password-auth0`,
      RESET_PASSWORD: `${API_PREFIX}/auth/reset-password-auth0`,
    };
  } else {
    // Default to Sanctum endpoints (simpler paths)
    return {
      LOGIN: `${API_PREFIX}/auth/login`,
      LOGOUT: `${API_PREFIX}/auth/logout`,
      FORGOT_PASSWORD: `${API_PREFIX}/auth/forgot-password`,
      RESET_PASSWORD: `${API_PREFIX}/auth/reset-password`,
    };
  }
};

const authEndpoints = getAuthEndpoints();

export const API_ROUTES = {
  ACTIVITY_CHECKLISTS: `${API_PREFIX}/activity-checklists`,
  LOGIN: authEndpoints.LOGIN,
  LOGOUT: authEndpoints.LOGOUT,
  FORGOT_PASSWORD: authEndpoints.FORGOT_PASSWORD,
  RESET_PASSWORD: authEndpoints.RESET_PASSWORD,
  USER_APPLICATION: `${API_PREFIX}/auth/application`,
  USER_INVITE: `${API_PREFIX}/auth/user-invite`,
  CURRENT_USER: `${API_PREFIX}/current-user`,
  CURRENT_USER_WATCHLIST_ACTIVE_COUNT: `${API_PREFIX}/current-user/watchlist-active-count`,
  CURRENT_USER_ATTACHMENTS: `${API_PREFIX}/current-user/attachments`,
  CURRENT_USER_ATTACHMENTS_DELETE: `${API_PREFIX}/current-user/attachments/delete`,
  CURRENT_USER_NOTIFICATIONS: `${API_PREFIX}/current-user/notifications`,
  CURRENT_COMPANY: `${API_PREFIX}/current-company`,
  CURRENT_COMPANY_INVENTORY_DEFAULTS: `${API_PREFIX}/current-company/preferences/inventory-defaults`,
  CURRENT_COMPANY_FULL: `${API_PREFIX}/current-company/full`,
  CURRENT_COMPANY_LICENSES: `${API_PREFIX}/current-company/licenses`,
  CURRENT_COMPANY_SUBSCRIBE: `${API_PREFIX}/current-company/licenses/subscribe`,
  CURRENT_COMPANY_PRO_SUBSCRIBE: `${API_PREFIX}/current-company/create-pro-subscription`,
  CURRENT_COMPANY_CHECK_PRO_SUBSCRIPTION: `${API_PREFIX}/current-company/validate-pro-subscription`,
  CURRENT_COMPANY_SET_ACH_ACCOUNT: `${API_PREFIX}/current-company/create-ach-account`,
  CURRENT_COMPANY_SET_DEFAULT_PAYMENT_METHOD: `${API_PREFIX}/current-company/set-default-payment-type`,
  CURRENT_COMPANY_CHECK_SUBSCRIPTION: `${API_PREFIX}/current-company/licenses/validate-subscription`,
  CURRENT_COMPANY_CANCEL_SUBSCRIPTION: `${API_PREFIX}/current-company/licenses/cancel-subscription`,
  CURRENT_COMPANY_LICENSES_TOGGLE_REDUCED_TESTING: `${API_PREFIX}/current-company/licenses/toggle-reduced-testing`,
  CURRENT_COMPANY_LICENSES_TOGGLE_CENTRAL_DISTRIBUTION: `${API_PREFIX}/current-company/licenses/toggle-central-distribution`,
  CURRENT_COMPANY_USERS: `${API_PREFIX}/current-company/users`,
  CURRENT_COMPANY_TRANSPORT_PREFERENCES: `${API_PREFIX}/current-company/transport-preferences`,
  CURRENT_COMPANY_BOXES: `${API_PREFIX}/current-company/boxes`,
  CURRENT_COMPANY_SHIPPING_ZONES: `${API_PREFIX}/current-company/shipping-zones`,
  CURRENT_COMPANY_CONTACTS: `${API_PREFIX}/current-company/contacts`,
  EXTERNAL_CONTACT_SYNC_STATUS: `${API_PREFIX}/current-company/contacts/external-status`,
  EXTERNAL_NEW_CONTACTS: `${API_PREFIX}/current-company/contacts/external-new`,
  EXTERNAL_SYNC_CONTACTS: `${API_PREFIX}/current-company/contacts/external-sync`,
  EXTERNAL_IMPORT_CONTACTS: `${API_PREFIX}/current-company/contacts/external-import`,
  CURRENT_COMPANY_POINT_OF_CONTACT: `${API_PREFIX}/current-company/point-of-contact`,
  CURRENT_COMPANY_CONTACT_PEOPLE: `${API_PREFIX}/company-contacts`,
  CURRENT_COMPANY_CONTACT_BY_LICENSE: `${API_PREFIX}/current-company/contacts/by-license-number`,
  CURRENT_COMPANY_CONTACT_UPDATE_PAYMENT_TERM: `${API_PREFIX}/current-company/contacts/update-payment-term`,
  CURRENT_COMPANY_LICENSE_RELATIONSHIPS: `${API_PREFIX}/current-company/license-relationships`,
  CURRENT_COMPANY_PRICING_PLANS: `${API_PREFIX}/current-company/pricing-plans`,
  CURRENT_COMPANY_PAYMENT_METHODS: `${API_PREFIX}/current-company/payment-methods`,
  CURRENT_COMPANY_NUVEI_MARKETPLACE_TOKENS: `${API_PREFIX}/current-company/nuvei/marketplace-tokens`,
  CURRENT_COMPANY_NUVEI_MARKETPLACE_PAYMENTS: `${API_PREFIX}/current-company/nuvei/marketplace-payments`,
  CURRENT_COMPANY_MENU_EXPORT: `${API_PREFIX}/current-company/menu-html`,
  CURRENT_COMPANY_SALES_REPS: `${API_PREFIX}/current-company/sales-reps`,
  CURRENT_COMPANY_MASTER_USER: `${API_PREFIX}/current-company/master-user`,
  API_TOKENS: `${API_PREFIX}/api-tokens`,
  LICENSE_EXISTS: `${API_PREFIX}/licenses/check-if-exists`,
  BRANDS: `${API_PREFIX}/brands`,
  BRANDS_DELETE: `${API_PREFIX}/brands/delete`,
  BRAND_STOREFRONTS: `${API_PREFIX}/brands/storefronts`,
  GENERIC_ORDERS: `${API_PREFIX}/generic-orders`,
  GENERIC_ORDER_APPROVAL: `${API_PREFIX}/generic-orders`,
  GENERIC_ORDER_QUALIFYING_PRODUCTS: `${API_PREFIX}/generic-orders`,
  GENERIC_ORDER_ALLOCATIONS: `${API_PREFIX}/generic-orders`,
  GENERIC_ORDER_FULFILLMENT: `${API_PREFIX}/generic-orders`,
  PRODUCT_LINES: `${API_PREFIX}/product-lines`,
  PRODUCT_SECTIONS: `${API_PREFIX}/product-sections`,
  CATEGORY_IMAGES: `${API_PREFIX}/admin/taxonomies/category-images`,
  CATEGORY_TYPES: `${API_PREFIX}/category-types`,
  CATEGORIES: `${API_PREFIX}/categories`,
  SUBCATEGORIES: `${API_PREFIX}/subcategories`,
  NON_METRC_CATEGORIES: `${API_PREFIX}/non-metrc-categories`,
  PRODUCTION_TYPES: `${API_PREFIX}/production-types`,
  TRIM_TYPES: `${API_PREFIX}/trim-types`,
  STRAIN_TYPES: `${API_PREFIX}/strain-types`,
  STRAINS: `${API_PREFIX}/strains`,
  STRAINS_METRC: `${API_PREFIX}/strains-metrc`,
  PAYMENT_TERMS: `${API_PREFIX}/payment-terms`,
  PAYMENT_STATUSES: `${API_PREFIX}/payment-statuses`,
  GROW_MEDIA: `${API_PREFIX}/grow-media`,
  CANNABINOIDS: `${API_PREFIX}/cannabinoids`,
  METRC_PACKAGE: `${API_PREFIX}/metrc/packages`,
  METRC_PACKAGES_ACTIVE_LIST: `${API_PREFIX}/metrc/packages/list/active`,
  METRC_PACKAGES_FROM_HARVESTS: `${API_PREFIX}/metrc/packages-from-harvests`,
  METRC_HARVESTS_ACTIVE_LIST: `${API_PREFIX}/metrc/harvests/list/active`,
  METRC_HARVESTS_CREATE_PACKAGES: `${API_PREFIX}/metrc/packages-from-harvests`,
  METRC_PACKAGES_POLLING: `${API_PREFIX}/metrc/packages/polling`,
  METRC_PACKAGES_POLLING_PROGRESS: `${API_PREFIX}/metrc/packages/polling/progress`,
  METRC_PACKAGES_BULK_VALIDATE_MAPPING: `${API_PREFIX}/metrc/packages/bulk/mapping-warnings`,
  PRODUCTION_DEFAULTS: `${API_PREFIX}/production/defaults`,
  PRODUCTION_CURRENT: `${API_PREFIX}/production/current`,
  PRODUCTION_PLANTS_POLLING: `${API_PREFIX}/production/plants/polling`,
  PRODUCTION_PLANTS_POLLING_PROGRESS: `${API_PREFIX}/production/plants/polling/progress`,
  PRODUCTION_HARVESTS: `${API_PREFIX}/production/harvests`,
  PRODUCTION_HARVESTS_POLLING: `${API_PREFIX}/production/harvests/polling`,
  PRODUCTION_HARVESTS_POLLING_PROGRESS: `${API_PREFIX}/production/harvests/polling/progress`,
  PRODUCTION_STRAINS_CURRENT: `${API_PREFIX}/production/strains`,
  METRC_ITEM: `${API_PREFIX}/metrc/items`,
  METRC_ITEMS_ACTIVE_LIST: `${API_PREFIX}/metrc/items/list/active`,
  METRC_LOCATIONS_ACTIVE_LIST: `${API_PREFIX}/metrc/locations/list/active`,
  METRC_FACILITIES_LIST: `${API_PREFIX}/metrc/facilities/list`,
  METRC_KEY_STATUS: `${API_PREFIX}/metrc/key-status`,
  METRC_ITEM_PRICE_SUGGESTIONS: `${API_PREFIX}/metrc/item-price-suggestions`,
  METRC_ITEM_SUPPLIERS: `${API_PREFIX}/metrc/items/suppliers`,
  METRC_SALES_LIST: `${API_PREFIX}/metrc/sales/list`,
  INGREDIENTS: `${API_PREFIX}/ingredients`,
  PRODUCTS: `${API_PREFIX}/products`,
  PRODUCTS_AI_DESCRIPTION: `${API_PREFIX}/products/ai-description`,
  PRODUCTS_IMAGES: `${API_PREFIX}/products/images`,
  PRODUCTS_IMAGES_DELETE: `${API_PREFIX}/products/images/delete`,
  MARKETPLACE_FACETS: `${API_PREFIX}/marketplace/facets`,
  LISTINGS: `${API_PREFIX}/listings`,
  LISTINGS_VALIDATE: `${API_PREFIX}/listings/validate`,
  LISTINGS_IMAGES: `${API_PREFIX}/listings/images`,
  LISTINGS_IMAGES_DELETE: `${API_PREFIX}/listings/images/delete`,
  LISTING_DRAFTS: `${API_PREFIX}/listings/drafts`,
  AUCTIONS: `${API_PREFIX}/auctions`,
  TAXONOMIES: `${API_PREFIX}/taxonomies`,
  COMPANIES: `${API_PREFIX}/companies`,
  USERS: `${API_PREFIX}/users`,
  USERS_MESSENGER: `${API_PREFIX}/messenger/users`,
  SALES: `${API_PREFIX}/sales`,
  PURCHASES: `${API_PREFIX}/purchases`,
  BUYER_REQUESTS: `${API_PREFIX}/buyer-requests`,
  PUBLIC_INVOICES: `${API_PREFIX}/public/invoices`,
  TRANSFERS: `${API_PREFIX}/transfers`,
  TRANSFER_TEMPLATE: `${API_PREFIX}/transfers/template`,
  TRANSFER_MANIFEST: `${API_PREFIX}/transfers/manifest`,
  TRANSFER_FROM_MANIFEST: `${API_PREFIX}/transfers/createFromManifest`,
  TRANSFER_ADD_CH: `${API_PREFIX}/transfers/addCannahauler`,
  INVENTORY_LISTINGS: `${API_PREFIX}/inventory-listings`,
  CONVERT_MEASURE_UNIT: `${API_PREFIX}/general/convert/measure-unit`,
  CONVERT_PRICE_PER_UNIT: `${API_PREFIX}/general/convert/price-per-unit`,
  PUBLIC_IMAGES: `${API_PREFIX}/public-images`,
  EXTERNAL: `${API_PREFIX}/external`,
  REORDER_INVENTORY: `${API_PREFIX}/inventory-reorders`,
  ORDERS: `${API_PREFIX}/orders`,
  AFFILIATED_TRANSFERS: `${API_PREFIX}/affiliated-transfers`,
  BUYER_ORDERS: `${API_PREFIX}/buyer-orders`,
  IN_HOUSE_DRIVERS: `${API_PREFIX}/licenses/get-drivers`,
  NEW_IN_HOUSE_DRIVER: `${API_PREFIX}/current-company/licenses/add-driver`,
  UPDATE_IN_HOUSE_DRIVER: `${API_PREFIX}/licenses/update-driver`,
  DELETE_IN_HOUSE_DRIVER: `${API_PREFIX}/licenses/delete-driver`,
  IN_HOUSE_VEHICLES: `${API_PREFIX}/current-company/licenses/get-vehicles`,
  NEW_IN_HOUSE_VEHICLE: `${API_PREFIX}/current-company/licenses/add-vehicle`,
  UPDATE_IN_HOUSE_VEHICLE: `${API_PREFIX}/current-company/licenses/update-vehicle`,
  DELETE_IN_HOUSE_VEHICLE: `${API_PREFIX}/current-company/licenses/delete-vehicle`,
  OTHER_LICENSES: `${API_PREFIX}/licenses/other`,
  REGISTRY_BUYERS: `${API_PREFIX}/licenses/registry-buyers`,
  CURRENT_COMPANY_BUYERS_LICENSES : `${API_PREFIX}/licenses/current-user-buyers-licenses`,
  ATTRIBUTES: `${API_PREFIX}/attributes`,
  ATTRIBUTE_TERMS: `${API_PREFIX}/attribute-terms`,
  AVAILABLE_PACKAGE_TAGS: `${API_PREFIX}/metrc/tags/package`,
  REPORTS: `${API_PREFIX}/reports`,
  PRICE_GROUPS: `${API_PREFIX}/pricing-templates`,
  PRICE_GROUP_REGISTRY_LICENSES: `${API_PREFIX}/pricing-templates/search-registry-licenses`,
  PRICE_GROUP_REGISTRY_SEARCH_DEFAULTS: `${API_PREFIX}/pricing-templates/registry-search-defaults`,
  PAYMENT_TERMS_GROUPS: `${API_PREFIX}/payment-terms-groups`,
  BULK_DISCOUNTS_GROUPS: `${API_PREFIX}/bulk-discounts`,
  PROMO_GROUPS: `${API_PREFIX}/promo-groups`,
  CART: `${API_PREFIX}/cart`,
  ADD_CREDITS: `${API_PREFIX}/customer-credits/grant`,
  GET_CREDITS: `${API_PREFIX}/customer-credits/balance`,
  GET_CREDIT_TRANSACTIONS: `${API_PREFIX}/customer-credits/history`,
  GET_GPS_SCHEDULE: `${API_PREFIX}/driver/schedule`,
  GET_CTS_ROUTE_AVAILABILITY: `${API_PREFIX}/cts/weekly-route-assignments/availability`,
  PERMISSIONS: `${API_PREFIX}/permissions`,
  CURRENT_COMPANY_USER_ROLES: `${API_PREFIX}/permissions/company/roles`,
  VOID_CREDIT_TRANSACTION: `${API_PREFIX}/customer-credits/void`,
  GET_BUYER_CREDITS: `${API_PREFIX}/customer-credits/buyer/all`,
  GET_BUYER_CREDIT_HISTORY: `${API_PREFIX}/customer-credits/buyer/history`,
  INVENTORY_BUCKETS: `${API_PREFIX}/inventory-buckets`,
  EXCLUDED_PACKAGES: `${API_PREFIX}/excluded-packages`,
  PACKAGE_MANAGEMENT: `${API_PREFIX}/package-management`,
  PRODUCT_TAGS: `${API_PREFIX}/products/tags`,
  PRODUCT_TAGS_API: `${API_PREFIX}/product-tags`,
  CUSTOMER_TAGS: `${API_PREFIX}/current-company/contacts/tags`,
  ORDER_PRO_PURCHASE_ORDER: `${API_PREFIX}/order-pro/purchase-orders`,
  PURCHASE_ORDERS: `${API_PREFIX}/purchase-orders`,
  EXTERNAL_VENDORS: `${API_PREFIX}/external-vendor`,
  EXTERNAL_VENDORS_CREATE: `${API_PREFIX}/external-vendors`,
  EXTERNAL_VENDOR_PRODUCT_LOOKUP: `${API_PREFIX}/external-vendor-products-product-lookup`,
  EXTERNAL_VENDOR_PRODUCTS_ALL: `${API_PREFIX}/external-vendor-products/get-all`,
  EXTERNAL_VENDOR_PRODUCTS: `${API_PREFIX}/external-vendor-products`,
  CHATS: `${API_PREFIX}/chats`,
  AI_ASSISTANT: `${API_PREFIX}/ai-assistant/`,
  CUSTOM_MENUS: `${API_PREFIX}/custom-menus`,
};
